
import { pr, React, theme, ui, observer } from "aaa";
import { NativeModal } from "./NativeModal";
import { NativeRaisedButton } from "./NativeRaisedButton";

export const ConfirmationDialog = observer((props: {
    show: boolean;
    onClose: (ok?: boolean) => void;
    title: string;
    message: string;
    labelOk?: string;
    labelCancel?: string;
}): any => {
    const okColor = ui.isDarkMode ? "#FF5555" : "#FF5555";
    const cancelColor = ui.isDarkMode ? "#86a8cf" : "#60768F";

    return (
        <NativeModal
            open={props.show}
            contentStyle={{ height: 1000, borderRadius: theme.BORDER_RADIUS }}
            paperStyle={{ borderRadius: theme.BORDER_RADIUS }}
            bodyStyle={{ borderTop: "none", borderBottom: "none", padding: 0, borderRadius: theme.BORDER_RADIUS }}
        >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#FF5555" }}>
                <pr.H1WithFocus style={{ fontFamily: "Inter Light", color: "white", fontSize: 20 }}>{props.title}</pr.H1WithFocus>
            </div>

            <pr.P_16_TITLE style={{ padding: 20 }}>
                {props.message}
            </pr.P_16_TITLE>
            <pr.LightSeparatorLine />

            <pr.HCenterDiv style={{ marginTop: 30, marginBottom: 30 }}>
                <NativeRaisedButton
                    style={{ height: 46, boxShadow: "" }}
                    buttonStyle={{ border: `1px solid ${cancelColor}`, borderRadius: theme.BORDER_RADIUS }}
                    labelStyle={{ textTransform: "none", color: cancelColor }}
                    label={props.labelCancel || ui.__("common.cancel")}
                    onClick={() => { props.onClose(false); }}
                />
                {props.labelOk && <NativeRaisedButton
                    style={{ marginLeft: 25, height: 46, boxShadow: "" }}
                    buttonStyle={{ border: `1px solid ${okColor}`, borderRadius: theme.BORDER_RADIUS }}
                    labelStyle={{ textTransform: "none", color: okColor, }}
                    label={props.labelOk}
                    onClick={() => { props.onClose(true); }}
                />}
            </pr.HCenterDiv>
        </NativeModal>
    );
});



// WEBPACK FOOTER //
// ./src/components/common/ConfirmationDialog.tsx